export default function HeaderContainer({ children }) {
  return (
    <div id="hero" className="bg-board">
      <div className="container text-white">{children}</div>
    </div>
  );
}
